/**
 * @desc 同步钉钉组织架构(新增)
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/organization/syncDingtalkDepartment`, {
      method: "GET",

      ...options,
    }),
  );
}
